import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DescuentosEmpleados } from '../../../interfaces/descuentosEmpleados';
import { ExemtedIva } from '../../../interfaces/exemptedIva';
import { TiposPago } from '../../../interfaces/tiposPago';
import { Bank } from '../../../interfaces/bank';
import { BankAccount } from '../../../interfaces/bankAccount';
import { SharedPanelService } from '../../../../dms/layout/shared-panel/shared-panel.service';
import { GestionTercerosService } from '../../../../dms/modulos/general/componentes/gestion-terceros/gestion-terceros.service';
import { TranslateService } from '@ngx-translate/core';
import { BankModel } from '../../../models/bank';
import { environment } from '../../../../../environments/environment';
import { GeneralGestionTercerosService } from '../../../../dms/modulos/general/componentes/gestion-terceros/servicios/general-gestion-tercerosService.Service';
import { distinctUntilChanged } from 'rxjs/operators';
import { AuthService } from '../../../services/auth.service';
declare let $: any;

@Component({
    selector: 'app-gestion',
    templateUrl: './gestion.component.html',
    styleUrls: ['./gestion.component.scss']
})

export class GestionComponent implements OnInit, OnDestroy {

    @Input() formMode: boolean;
    @Input() modoEdicion: boolean;

    discountMO: DescuentosEmpleados[];
    discountPR: any[];
    exemptions: ExemtedIva[];
    modePaid: TiposPago[];
    bankCodes: any[];
    ExemptionVatCodeCustomer: ExemtedIva;
    public bankCode: number;
    public banDescription: string;
    newBanks: Bank[] = [];
    bankAccount: BankAccount;
    public formBankAccount: FormGroup;
    public selectedValue: string;
    public min: number = 0;
    public max: number = 10000000;
    error: string;
    code: string;
    public formatOptions: any = {
        style: 'percent',
        currency: '%',
        currencyDisplay: 'name'
    };
    public formatOptionsEuros: any = {
        style: 'currency',
        currency: 'EUR',
        currencyDisplay: 'symbol'
    };
    textObligado: string;
    ifErrorCreditLimit: string;
    textMaxNumero: string;
    gestion: Subscription;
    bank5: Subscription;
    isCreadoCustomer: Subscription;
    pais: string;

    constructor(
        public _generalGestionTercerosService: GeneralGestionTercerosService,
        private route: ActivatedRoute,
        public _sharedPanelService: SharedPanelService,
        public _gestionTercerosService: GestionTercerosService,
        private _translateService: TranslateService,
        private _authService: AuthService
    ) {
        this.ifErrorCreditLimit = '';
    }

    ngOnDestroy() {
        if(this.isCreadoCustomer){
            this.isCreadoCustomer.unsubscribe();
        }
        if(this.gestion){
            this.gestion.unsubscribe();
        }
    }

    ngOnInit() {
        this.pais = this._authService.getDataPais();
        this._translateService.get('errors.numberBig').subscribe(text => {
            this.textMaxNumero = text;
        });

        this.descMo();  // 1
        this.descPiezas(); // 2
        if(this.pais === 'es'){
            this.getIva();
        }else{
            this.exentoIva(); // 3
        }
        this.modosPago(); //4
        this.customerbankCodes(); //5

        this.isCreadoCustomer = this._gestionTercerosService.observerCreadoCustomer().subscribe(val => {
            if (val === true) {
                this.comprobarPestana();
            }
        });

        this.gestion = this._gestionTercerosService.customerForm.controls.gestion.valueChanges.pipe(distinctUntilChanged()).subscribe(val => {
            this.comprobarPestana();
        });

        this.ibanValidation();
        this.comprobarPestana();
    }

    ibanValidation() {
            const iban = this._gestionTercerosService.customerForm.get('gestion').get('Iban').value;
            const auxValue = iban.Country + iban.CheckDigit + iban.BankCode + iban.BranchCode + iban.NationalCheckDigit + iban.AccountNumber;
            const dataValidateIban = { requestObject: auxValue };

            if (iban.CheckDigit && iban.BankCode && iban.BranchCode && iban.NationalCheckDigit && iban.AccountNumber) {
                this._gestionTercerosService.camposIbanCompletos = true;

                if(auxValue !== "ES0000000000000000000000" && auxValue.length === 24){
                    this._gestionTercerosService.validateIbanCode(JSON.stringify(dataValidateIban)).subscribe(resp => {
                        this._gestionTercerosService.isValidIban = resp.IsValid;
                        if (this._gestionTercerosService.isValidIban) {
                            this._gestionTercerosService.customerForm.get('gestion').get('Iban').setValue(resp, { emitEvent: false });
                        }else{
                            this._gestionTercerosService.customerForm.get('gestion').get('Iban').get('Value').setValue('', { emitEvent: false });
                        }
                    });
                }else{
                    this._gestionTercerosService.isValidIban = true;
                    this._gestionTercerosService.customerForm.get('gestion').get('Iban').get('Value').setValue('', { emitEvent: false });
                }
            } else {
                this._gestionTercerosService.isValidIban = true;
                this._gestionTercerosService.camposIbanCompletos = false;
                this._gestionTercerosService.customerForm.get('gestion').get('Iban').get('Value').setValue('', { emitEvent: false });
            }
    }

    comprobarPestana() {
        const pestanaDatosGestion = this._gestionTercerosService.customerForm.controls.gestion.invalid;
        if (pestanaDatosGestion) {
            $('#gestion').parent().parent().find('li.k-state-active').addClass('pestana_error');
        } else {
            $('#gestion').parent().parent().find('li.k-state-active').removeClass('pestana_error');
        }
    }

    descMo() {
        const _URL_ = `${environment.ENTORNO}${environment.SessionService.General}${environment.SessionService.ENDPOINT.LaborDiscountCodesService}`;
        const params = {
            'searchValue': '',
            'pageInfo': {
                'Number': 1,
                'Size': 50
            }
        };
        this._generalGestionTercerosService.getlaborDiscount(_URL_, params).subscribe(data => {
            const auxdata = data.Response.Content;
            if (auxdata) {
                this.discountMO = auxdata;
            }
        });
    }

    descPiezas() {
        const _URL_ = `${environment.ENTORNO}${environment.SessionService.General}${environment.SessionService.ENDPOINT.CustomerPRDiscountsService}`;
        const parametros = '';

        this._generalGestionTercerosService.getDiscountPR(_URL_, parametros).subscribe(data => {
            const auxdata = data.Response;
            if (auxdata) {
                this.discountPR = auxdata;
            }
        });
    }

    //solo para ES
    getIva() {
        const _URL_ = `${environment.ENTORNO}${environment.SessionService.General}VatTypeService.svc/GetAll`;
        const parametros = '';
        this._generalGestionTercerosService.getCustomerExemption(_URL_, parametros).subscribe(data => {
            const auxdata = data.Response;
            if (auxdata) {
                this.exemptions = auxdata;
            }
        });
    }

    //para el resto de paises que no sea ES
    exentoIva() {
        const _URL_ = `${environment.ENTORNO}${environment.SessionService.General}${environment.SessionService.ENDPOINT.GetExempted}`;
        const parametros = '';

        this._generalGestionTercerosService.getCustomerExemption(_URL_, parametros).subscribe(data => {
            const auxdata = data.Response;
            if (auxdata) {
                this.exemptions = auxdata;

                this.mapearExemptions();
            }
        });
    }

    modosPago() {
        const _URL_ = `${environment.ENTORNO}${environment.SessionService.General}${environment.SessionService.ENDPOINT.PaymentTypes}`;
        const parametros = {
            'searchValue': '',
            'OrderBy': null
        };

        this._generalGestionTercerosService.getCustomerModePaid(_URL_, parametros).subscribe(data => {
            const auxdata = data.Response;
            if (auxdata) {
                this.modePaid = auxdata;
            }
        });
    }

    customerbankCodes() {
        this.bankCodes = this.route.snapshot.data.bankCodes ? [...this.route.snapshot.data.bankCodes] : [];
        this.mapearBankCodes();
    }

    mapearExemptions() {
        this.exemptions.map((item, i) => {
            item.ExemptionVatCode = item.VatCode;
        });
    }

    public valueChangeIva(value: any): void {
        this._gestionTercerosService.customerForm.get('gestion').get('ExemptionVatCode').setValue(value, { emitEvent: false });
    }

    escribirCeros(cual) {
        const auxValor = this._gestionTercerosService.customerForm.get('gestion').get('Iban').get(cual).value;
        if (!auxValor) {
            switch (cual) {
                case 'CheckDigit':
                    this._gestionTercerosService.customerForm.get('gestion').get('Iban').get(cual).setValue('00', { emitEvent: false });
                    break;
                case 'BankCode':
                    this._gestionTercerosService.customerForm.get('gestion').get('Iban').get(cual).setValue('0000', { emitEvent: false });
                    break;
                case 'BranchCode':
                    this._gestionTercerosService.customerForm.get('gestion').get('Iban').get(cual).setValue('0000', { emitEvent: false });
                    break;
                case 'NationalCheckDigit':
                    this._gestionTercerosService.customerForm.get('gestion').get('Iban').get(cual).setValue('00', { emitEvent: false });
                    break;
                case 'AccountNumber':
                    this._gestionTercerosService.customerForm.get('gestion').get('Iban').get(cual).setValue('0000000000');
                    break;
            }
        }
    }

    public valueChange(value: any): void { }

    mapearBankCodes() {
        this.bankCodes.map((item, i) => {
            item = this.reasignar(item, i);
        });
    }

    reasignar(item, index) {
        const bankSelect = new BankModel();
        bankSelect.bankCode = index;
        bankSelect.bankDescription = item;

        const arrayDescription = item.split('!');
        bankSelect.bankName = arrayDescription[0];
        this.newBanks.push(bankSelect);
    }

    clickCheckBox(event) {
        const auxChech = event.currentTarget.id;
        const value = this._gestionTercerosService.customerForm.controls.gestion.get(auxChech).value;
    }

    hasError(name) {
        return this._gestionTercerosService.customerForm.controls.gestion.get(name).hasError('required')
            && this._gestionTercerosService.customerForm.controls.gestion.get(name).touched;
    }

    getValueControl(name) {
        return this._gestionTercerosService.customerForm.controls.gestion.get(name).value === '' || this._gestionTercerosService.customerForm.controls.gestion.get(name).value === null;
    }

    blurElementGestion(name) {
        if (this._gestionTercerosService.customerForm.controls.gestion.get(name).invalid) {
            return true;
        } else {
            return false;
        }
    }

}
